import MessageDraftsAPI from 'dashboard/api/messageDrafts';

const DRAFT_KEY = 'chatwoot_compose_draft';

export default async function migrateNewConversationDraft() {
  const draftData = localStorage.getItem(DRAFT_KEY);
  if (!draftData) return;

  const draft = JSON.parse(draftData);

  const hasContent =
    draft.message ||
    draft.subject ||
    draft.selectedContactId ||
    draft.targetInboxId;

  if (!hasContent) {
    localStorage.removeItem(DRAFT_KEY);
    return;
  }

  const ccEmails = draft.ccEmails
    ? draft.ccEmails
        .split(',')
        .map(e => e.trim())
        .filter(Boolean)
    : [];
  const bccEmails = draft.bccEmails
    ? draft.bccEmails
        .split(',')
        .map(e => e.trim())
        .filter(Boolean)
    : [];

  await MessageDraftsAPI.create({
    publicContent: draft.message || undefined,
    subject: draft.subject || undefined,
    contactId: draft.selectedContactId || undefined,
    inboxId: draft.targetInboxId || undefined,
    ccEmails: ccEmails.length ? ccEmails : undefined,
    bccEmails: bccEmails.length ? bccEmails : undefined,
  });

  localStorage.removeItem(DRAFT_KEY);
}
